
import bannerMitraPaxel from './routes/banner/Banner.vue';

import customerList from './routes/customer-list/customerList.vue';
import detailCustomer from './routes/customer-list/component/detailCustomer.vue';

const MitraPaxelRoutes = [
      {
        path: '/banner',
        name: 'bannerMitraPaxel',
        component: bannerMitraPaxel,
      },
      {
        path: '/customer-list',
        name: 'customerList',
        component: customerList,
      },
      {
        path: '/detail-customer/:id',
        name: 'detailCustomer',
        component: detailCustomer,
      },

];

export default MitraPaxelRoutes;
